import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-5 z-40 inline-flex items-center justify-center w-11 h-11 rounded-full border border-primary-300 bg-background-50 text-primary-600 cursor-pointer transition-colors hover:bg-primary-500 hover:text-background-50"
    >
      <i className="ri-arrow-up-line w-5 h-5 flex items-center justify-center"></i>
    </button>
  );
}